import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="container" style={{ textAlign: "center", paddingTop: "4rem" }}>
      <p style={{ fontSize: "4rem", marginBottom: "1rem" }}>404</p>
      <h1 style={{ fontSize: "1.5rem", fontWeight: 700, marginBottom: "0.5rem" }}>
        Page not found
      </h1>
      <p style={{ color: "var(--color-text-secondary)", marginBottom: "2rem" }}>
        The page you're looking for doesn't exist yet.
      </p>
      <Link
        to="/"
        style={{
          background: "var(--color-accent)",
          color: "#fff",
          padding: "0.5rem 1.5rem",
          borderRadius: "var(--radius-md)",
          fontWeight: 600,
        }}
      >
        Go home
      </Link>
    </div>
  );
}
